export default __webpack_public_path__ + "static/media/IMG_9909.b8183e64.jpg";